import { Form } from 'vform'

const session = {
    state: () => ({
        form: new Form({
            'sessions': [],
            'grand_total_price': 0,
            'total': 0,
            'tier_adjustment': 0,
            'grand_total': 0,
        })
    }),

    mutations: {
        // 
    },

    getters: {
        // 
    }
}

export default session;
